import { Box, Image, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const Room = ({ room, people, checkin, checkout, onClick }) => {

  const { t } = useTranslation();
  

  // const notas = {
  //   "pirul": "6 personas + 1 adicional con costo.",
  //   "mezquite": "10 personas + 1 adicional con costo.",
  //   "bambu": "4 personas + 1 adicional con costo."
  // }

  // const renderNota = (cabana) => {
  //   let nombreCabana = cabana.toLowerCase();
  //   if(nombreCabana === "bambú") {
  //     nombreCabana = "bambu";
  //   }
  //   if(notas[nombreCabana]) {
  //     return (
  //       <span className="mt-3">
  //         <span className="fw-bold">{t('NOTE')} </span><span>{notas[nombreCabana]}</span>
  //       </span>
  //     )
  //   }
  //   return null;
  // }

  return (
    <Box
      width={'auto'}
      backgroundColor="gray.100"
      p={2}
      borderRadius="5"
      my={2}
    >
      <div className="my-2 overflow-auto d-flex flex-column">
        <span>{room.name}</span>
        <Image
          backgroundColor={'rebeccapurple'}
          borderRadius={5}
          my="5"
          src={room.photos[0]}
        />
        <span>
          {t('MAX_OCCUPANTS')} {room.max_occupancy}
        </span>
        <span>
          {t('CHECKIN')} {checkin}
        </span>
        <span>
          {t('CHECKOUT')} {checkout}
        </span>
        <Button
          colorScheme={'orange'}
          onClick={() => onClick(room, room.max_occupancy)}
          className="mt-4"
          style={{ 
            width: '100%',
            maxWidth: '400px',
          }}
        >
          {t('SELECT')}
        </Button>
      </div>
    </Box>
  );
};

export default Room;
